var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlatInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 20.834C17.102 20.834 20.833 17.103 20.833 12.5007C20.833 7.89828 17.102 4.16732 12.4997 4.16732C7.8973 4.16732 4.16634 7.89828 4.16634 12.5007C4.16634 17.103 7.8973 20.834 12.4997 20.834ZM12.4997 22.9173C18.2526 22.9173 22.9163 18.2536 22.9163 12.5007C22.9163 6.74768 18.2526 2.08398 12.4997 2.08398C6.74671 2.08398 2.08301 6.74768 2.08301 12.5007C2.08301 18.2536 6.74671 22.9173 12.4997 22.9173Z",
    fill: "#0078FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 7.29102C11.9244 7.29102 11.458 7.75739 11.458 8.33268C11.458 8.90798 11.9244 9.37435 12.4997 9.37435C13.075 9.37435 13.5413 8.90798 13.5413 8.33268C13.5413 7.75739 13.075 7.29102 12.4997 7.29102ZM12.4997 11.4577C11.9244 11.4577 11.458 11.9241 11.458 12.4993V16.666C11.458 17.2413 11.9244 17.7077 12.4997 17.7077C13.075 17.7077 13.5413 17.2413 13.5413 16.666V12.4993C13.5413 11.9241 13.075 11.4577 12.4997 11.4577Z",
    fill: "#0078FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatInfoIcon);
export default __webpack_public_path__ + "static/media/FlatInfoIcon.20a2797c.svg";
export { ForwardRef as ReactComponent };